import { api } from './client';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface User {
  id: string;
  email: string;
  name: string;
  role: 'admin' | 'user';
  tenantId: string | null;
  userKind?: 'PLATFORM' | 'TENANT';
  scope?: 'platform' | 'tenant';
  isProtected?: boolean;
  roles?: string[];
  /** 权限码列表，与后端 JWT / me 一致 */
  permissions?: string[];
  /** 与后端 mergeRoleMenuKeys 一致 */
  menuKeys?: string[];
}

export interface LoginResponse {
  accessToken: string;
  user: User;
}

export interface RegisterPayload {
  email: string;
  password: string;
  tenantName: string;
}

export const authApi = {
  login: (credentials: LoginCredentials) =>
    api.post<LoginResponse>('/api/auth/login', credentials),

  register: (payload: RegisterPayload) =>
    api.post<LoginResponse>('/api/auth/register', payload),

  me: () => api.get<User>('/api/auth/me'),
};
